import State from '@/classes/state';
import Filter from '@/models/filter.model';

const getters = {
    /**
     * Checks if the given filter
     * is currently selected
     */
    isSelectedFilter(state: State) {
        return (filter: Filter) => {
            return state.selectedFilters.some(filterGroupFilterCombi => filterGroupFilterCombi.filter.id === filter.id);
        };
    },
};

export default getters;
